import { useEffect, useState } from "react";
import { LeaderboardRepository } from "../../api/repositories/stats/leaderboard";
import { LeaderboardPlayer } from "../../api/repositories/stats/models/leaderboard";
import { localize } from "../../common/services/localization";
import { PageContainer } from "../components/layout/page";
import { SearchInput } from "../components/functional/inputs";
import { BlueButton, OrangeButton } from "../components/functional/buttons";
import { PlayersRepository } from "../../api/repositories/stats/players";
import { PlayerShort } from "../../api/repositories/stats/models/players";
import { href } from "react-router-dom";

export const PlayersSearch: React.FC = () => {
    const [response, setResponse] = useState<ApiDataResponse<PlayerShort> | undefined>();
    const [playerId, setPlayerId] = useState<number | undefined>();
    const repository = new PlayersRepository();

    function updateSearchValue(e: React.ChangeEvent<HTMLInputElement>) {
        setPlayerId(parseInt(e.target.value));
    }

    return <PageContainer
        staticBg={true}
        containerClassName='w-[883px] flex flex-col justify-center items-center'
        headerImgPath='/v2/images/bg/towers.png'
        child={
            <div className='px-[10px] sm:px-[0px] w-full sm:w-[540px] md:w-[660px] lg:w-[883px] min-h-[360px] flex flex-col gap-[60px]'>
                <div className=''>
                    <h2 className="mb-4">{localize('players_search_title')}</h2>
                </div>
                <div className="flex flex-row justify-between gap-[12px]">
                    <SearchInput
                        placeholderLocal="players_search_input_placeholder"
                        className="w-full"
                        type="number"
                        maxLength={2}
                        onChange={updateSearchValue}
                    />
                    <OrangeButton
                        localText="players_search_btn"
                        className="px-[24px] py-[14px] text-[14px] lg:text-[18px]"
                        disabled={!playerId}
                        onClick={() => {
                            if (playerId)
                                repository.getShort(playerId)
                                    .then(t => setResponse(t))
                        }}
                    />
                </div>
                {
                    response
                        ? response.hasErrors
                            ? <div className="flex flex-col justify-center text-center items-center gap-[8px]">
                                <span className="text-[28px] font-semibold uppercase">
                                    {localize("player_not_found_title")}
                                </span>
                                <span className="font-['Roboto'] text-center lg:w-[500px]">
                                    {localize("player_not_found_search")}
                                </span>
                            </div>
                            : <ShortPlayerBlock player={response.data!} />
                        : null
                }
            </div >
        }
    />
}

const ShortPlayerBlock: React.FC<{
    player: PlayerShort
}> = ({ player }) => {
    return <div className="flex flex-col gap-y-[32px] ">
        <div className="flex flex-row justify-between gap-[18px] text-16 ">
            <div>
                <div className="text-[18px] uppercase font-['Roboto'] text-gray mb-[8px]">
                    {localize("player_name")}
                </div>
                <div className="text-[16px] lg:text-[24px] font-semibold">
                    {player.name ?? 0}
                </div>
            </div>
            <div>
                <div className="text-[18px] uppercase font-['Roboto'] text-gray mb-[8px]">
                    {localize("player_rating")}
                </div>
                <div className="text-[16px] lg:text-[24px] font-semibold">
                    {player.rating ?? 0}
                </div>
            </div>
        </div>
        <BlueButton
            textClassName="text-[14px] lg:text-[18px]"
            localText="player_search_profile_btn"
            onClick={() => {
                window.location.href = `/players/${player.id}`
            }}
        />
    </div>
}

